<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeItemResumo from "./LinhaDeItemResumo.vue";
import LinhaDeItemDetalhes from "./LinhaDeItemDetalhes.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
]);

const emits = defineEmits([
    "update:alteraItem",
]);

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) =>{

    update.id = props?.item?.id;
    emits('update:alteraItem',update);

};

</script>

<template>

    <div
        class="c-table__row-group"
    >

        <LinhaDeItemResumo
            :dado="props?.dado"
            :item="props?.item"
            @update:alteraItem="alteraItem"
        ></LinhaDeItemResumo>

        <LinhaDeItemDetalhes
            :dado="props?.dado"
            :item="props?.item"
        ></LinhaDeItemDetalhes>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>
